import React, { ReactElement } from 'react';
import { Lieu } from '../../../../../common/src/entities';
import ChampMultiple, { affichageElementDefaut } from '../../Common/ChampMultiple';
import { ArrayHelpers } from 'formik';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { PopoutEntite } from '../Utils/PopoutEntite';
import CreerLieu from './CreerLieu';
import { affichageLieu } from './DetailsLieu';
import { ValueType } from 'react-select';

interface PropsAffichageAjoutLieu {
    helpers: ArrayHelpers;
    values: Lieu[];
    avecUnBouton?: boolean;
    title?: string;
    maxSize?: number;
}

function AffichageAjoutLieu(props: PropsAffichageAjoutLieu): ReactElement {
    const bsAlert = useAlertDialog();

    function gererOnChange(value: ValueType<Lieu, false>): void {
        const lieu = value as Lieu;
        if (!lieu) return;

        if (props.values.find((item) => item.id === lieu.id)) {
            bsAlert('Ce lieu est déja associé!', 'warning');
            return;
        } else if (props.maxSize && props.values.length === props.maxSize) {
            bsAlert(`Vous ne pouvez qu'ajouter un max de ${props.maxSize} élément(s)`, 'warning');
            return;
        }
        props.helpers.push(value);
    }

    return (
        <PopoutEntite
            titre={`Ajouter un ${props.title?.toLowerCase() ?? 'lieu'}`}
            entite={Lieu}
            isCreatable
            modalSize="lg"
            modalBody={(props) => <CreerLieu {...props} />}
            size="sm"
            disabled={props.maxSize === props.values.length ? true : false}
            getOptionLabel={(option) => affichageLieu(option)}
            onChange={gererOnChange}
            avecUnBouton={props.avecUnBouton}
        />
    );
}

export interface PropsChampMultipleLieu {
    id: string;
    avecUnBouton?: boolean;
    labelCol?: number;
    maxSize?: number;
    title?: string;
}

export default function ChampMultipleLieu(props: PropsChampMultipleLieu): ReactElement {
    const affichageAjoutLieu = (values, helpers, maxSize?: number, title?: string) => (
        <AffichageAjoutLieu
            helpers={helpers}
            values={values}
            maxSize={maxSize}
            title={title}
            avecUnBouton={props.avecUnBouton}
        />
    );
    return (
        <ChampMultiple
            entite={Lieu}
            titre={`${props.title ?? 'Lieux'}`}
            {...props}
            affichageAjout={affichageAjoutLieu}
            affichageTexte={(lieu: Lieu | number) => affichageLieu(lieu as Lieu)}
            affichageElement={affichageElementDefaut(Lieu)}
            labelCol={props.labelCol}
        />
    );
}
